import { useEffect, useState } from 'react';
import { useAuth } from './lib/auth.jsx';
import { DataProvider, useData } from './lib/data.jsx';
import { todayISO, thDate, TH_D, parseD } from './lib/util.js';
import Login from './pages/Login.jsx';
import SetPassword from './pages/SetPassword.jsx';
import Home from './pages/Home.jsx';
import NewRental from './pages/NewRental.jsx';
import Return from './pages/Return.jsx';
import Credits from './pages/Credits.jsx';
import Dash from './pages/Dash.jsx';
import CalendarPage from './pages/Calendar.jsx';
import Customers from './pages/Customers.jsx';
import TradeIn from './pages/TradeIn.jsx';
import Fleet from './pages/Fleet.jsx';
import AuditLog from './pages/AuditLog.jsx';
import Settings from './pages/Settings.jsx';

// แท็บไหนต้องใช้สิทธิ์อะไร (ตาม prototype)
const NAV = [
  ['home', 'หน้าหลัก', null],
  ['new', 'เปิดสัญญาเช่า', 'rent.create'],
  ['return', 'รับคืน / ตรวจสภาพ', 'rent.return'],
  ['credit', 'เครดิตเช่า→ซื้อ', 'credit.use'],
  ['dash', 'รายรับ', 'report.view'],
  ['cal', 'ปฏิทินคลัง', 'rent.book'],
  ['cust', 'ลูกค้า', 'cust.edit'],
  ['trade', 'Trade-in', 'tradein.accept'],
  ['fleet', 'คลังเช่า', null],
  ['log', 'ประวัติ', 'log.view'],
  ['set', 'ตั้งค่า', null],   // ในหน้า จะ gate รายแท็บย่อยอีกชั้น
];

function Shell() {
  const { me, can, signOut } = useAuth();
  const { openContracts, credits } = useData();
  const [view, setView] = useState(() =>
    new URLSearchParams(location.search).get('v') || 'home');
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const on = () => setOnline(true), off = () => setOnline(false);
    window.addEventListener('online', on); window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, []);

  const today = todayISO();
  const nActiveCredits = credits.filter(c => c.status === 'active').length;
  const counts = { return: openContracts.length, credit: nActiveCredits };

  const go = (v) => { setView(v); window.scrollTo(0, 0); };

  const pages = {
    home: <Home go={go} />, new: <NewRental go={go} />, return: <Return go={go} />,
    credit: <Credits />, dash: <Dash />, cal: <CalendarPage />, cust: <Customers go={go} />,
    trade: <TradeIn />, fleet: <Fleet />, log: <AuditLog />, set: <Settings />,
  };

  return (<>
    {!online && <div className="offline">ออฟไลน์ — ดูข้อมูลได้ แต่การเปิด/ปิดสัญญาและรายการเงินถูกปิดไว้จนกว่าเน็ตจะกลับมา</div>}
    <header><div className="wrap">
      <div className="hd">
        <img className="hdlogo" src="/logo-ink.svg" alt="Camp Studio" />
        <div className="logo">Rent<em>Point</em></div>
        <div className="sub">เช่า / Trade-in</div>
        <div className="date">{TH_D[parseD(today).getDay()]}. {thDate(today)} · {me.branch_name || 'สาขาหลัก'}</div>
        <button className="who" title="ออกจากระบบ" onClick={() => { if (confirm('ออกจากระบบ?')) signOut(); }}>
          {me.name} · {me.role} ✕
        </button>
      </div>
      <nav className="mainnav">
        {NAV.filter(([, , perm]) => !perm || can(perm)).map(([k, label]) => (
          <button key={k} className={view === k ? 'on' : ''} onClick={() => go(k)}>
            {label}{counts[k] ? <span className="n">{counts[k]}</span> : null}
          </button>
        ))}
      </nav>
    </div></header>
    <main className="wrap">
      <section className="view">{pages[view] || pages.home}</section>
    </main>
  </>);
}

export default function App() {
  const { session, me, boot, bootErr } = useAuth();
  const isRecovery = new URLSearchParams(location.search).get('v') === 'setpw' ||
    location.hash.includes('type=recovery');

  if (isRecovery) return <SetPassword />;
  if (session === undefined) return <div className="empty" style={{ paddingTop: 120 }}>กำลังโหลด…</div>;
  if (bootErr) return <div className="empty" style={{ paddingTop: 120 }}>โหลดข้อมูลไม่สำเร็จ: {bootErr}</div>;
  if (!session || !me) return <Login />;
  return <DataProvider><Shell /></DataProvider>;
}
